import { render } from "./OrderItem.vue?vue&type=template&id=b294720a&scoped=true"
import script from "./OrderItem.vue?vue&type=script&lang=js"
export * from "./OrderItem.vue?vue&type=script&lang=js"

import "./style.scss?vue&type=style&index=0&id=b294720a&lang=scss&scoped=true"
import "../../order-detail/style.scss?vue&type=style&index=1&id=b294720a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b294720a"]])

export default __exports__